module.exports = __webpack_public_path__ + "img/yydk.8f615a46.png";